import { useState } from 'react';
import { RouterProvider } from 'react-router/dom';

import { AppProviders } from './providers';
import { createAppRouter } from './router';
import type { AppRuntime } from './runtime';

export function App({ runtime }: { runtime: AppRuntime }) {
  const [router] = useState(() => createAppRouter(runtime.registry));
  return (
    <AppProviders runtime={runtime}>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
